'use client';

import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '../utils/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'border-input bg-background flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm transition-colors',
        // Lighter placeholder so multi-line hint text doesn't read as
        // "already filled" - matches the Input primitive's tone.
        'placeholder:text-muted-foreground/50',
        // Focus highlights the field's own border (no offset ring sitting outside it).
        'focus-visible:border-ring focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
